import moment from 'moment-timezone';

import { Interview, Status } from './Types';
import { PARTICIPANT_TYPE, Interviewer } from './services';

const HOST_NAME_LOCAL = '.harver.local';
const HP_CLIENT_BASE_URL_LOCAL = 'https://admin.harver.local';

export function isValidEmail(email: string) {
    return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
}

export function isValidUrl(url: string): boolean {
    url = url.trim();
    const validProtocolRegExp = /^(http|https):\/\/(.*)/i;
    if (!validProtocolRegExp.test(url)) return false;
    try {
        new URL(url);
        return true;
    } catch (err) {
        return false;
    }
}

export function isValidEmailLogoUrl(url: string): boolean {
    url = url.trim();
    const validProtocolRegExp = /^(http|https):\/\/(.*)\.(png|jpg|jpeg)$/i;
    if (!validProtocolRegExp.test(url)) return false;
    try {
        new URL(url);
        return true;
    } catch (err) {
        return false;
    }
}

export function isContainingSpecialCharacters(text: string): boolean {
    const format = /[!@#$%^&*()+\\[\]{};'"\\|,<>\/?]+/;

    if (format.test(text)) {
        return true;
    } else {
        return false;
    }
}

export function getSchedulingServerURL(): string {
    const adminDomain = process.env.ADMIN_COOKIE_DOMAIN || '.harver.local';
    const serverAdminBaseURL = process.env.SERVER_ADMIN_APP_BASE || 'https://api-scheduling.harver.local';

    let schedulingServerBase = process.env.REACT_APP_SCHEDULING_BASE as string;
    if (window.location.hostname.includes(adminDomain)) {
        schedulingServerBase = serverAdminBaseURL;
    }

    return schedulingServerBase;
}

export const getHpClientBaseUrl = (): string => {
    let hpClientBaseUrl = process.env.REACT_APP_HARVER_PLATFORM_BASE_URL as string;
    if (window.location.hostname.includes(HOST_NAME_LOCAL)) {
        hpClientBaseUrl = HP_CLIENT_BASE_URL_LOCAL;
    }

    return hpClientBaseUrl;
};

export const getLabelsFromOption = (options: any[], value: any, key: string) => {
    return options.find((option) => option[key] == value) || value;
};

// TODO: Align other places with this common function and remove the redundant function
// To check and remove - client/src/HarverPages/interviewHistory/service.ts
export const displayInterviewersStatus = [Status.scheduled, Status.cancelled, Status.completed];

export const getAssignedInterviewers = (interview: Interview): string[] => {
    const assignedInterviewers = [] as string[];
    if (displayInterviewersStatus.includes(interview.status)) {
        if (interview.virtualCalendars.length > 0) {
            interview.virtualCalendars.forEach(({ isAttendee, name }) => {
                if (isAttendee === true) {
                    assignedInterviewers.push(name);
                }
            });
        }

        if (interview.interviewers.length > 0) {
            interview.interviewers.forEach(({ isAttendee, firstName, lastName, email }) => {
                if (isAttendee === true) {
                    assignedInterviewers.push(`${firstName} ${lastName}`.trim() || email);
                }
            });
        }
    }

    return assignedInterviewers;
};

export const getAssignedInterviewersDetails = (interview: Interview): Interviewer[] => {
    const assignedInterviewers = [] as Interviewer[];
    if (interview.virtualCalendars.length > 0) {
        interview.virtualCalendars.forEach(({ isAttendee, name, virtualCalendarId, owner }) => {
            if (isAttendee === true) {
                assignedInterviewers.push({
                    name: name,
                    id: virtualCalendarId,
                    email: owner ?? '',
                    type: PARTICIPANT_TYPE.VIRTUAL_CALENDAR,
                });
            }
        });
    }

    if (interview.interviewers.length > 0) {
        interview.interviewers.forEach(({ isAttendee, firstName, lastName, email }) => {
            if (isAttendee === true) {
                assignedInterviewers.push({
                    name: `${firstName} ${lastName}`.trim(),
                    id: '',
                    email: email,
                    type: PARTICIPANT_TYPE.INTERVIEWER,
                });
            }
        });
    }
    return assignedInterviewers;
};

export const formatDateAndTime = (dateAndTime: string): string => {
    return moment(dateAndTime).format('DD MMMM YYYY HH:mm:ss');
};

export const formatDateAndTimeDDMMM12H = (dateAndTime: string): string => {
    return moment(dateAndTime).format('DD MMM, h:mm A');
};

export const splitStringBasedOnCharacterLength = (line: string, length: number) => {
    if (line.length <= length) {
        return [line];
    }

    const regex = new RegExp(`.{1,${length}}`, 'g');
    const substrings = line.match(regex) as string[];

    return substrings;
};

export function generateTestId(label: string): string {
    return label
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-');
}
